import { polyfillWebCrypto } from 'expo-standard-web-crypto';
polyfillWebCrypto();
